import { render, staticRenderFns } from "./SetupClientPaymentForm.vue?vue&type=template&id=70cb815e&"
import script from "./SetupClientPaymentForm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SetupClientPaymentForm.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SetupClientPaymentForm.vue?vue&type=style&index=0&id=70cb815e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports